import React from "react";
import { Grid, Typography } from "@mui/material";
import { appContext } from "../../../../AppContext";
import IbssTextField from "../../../../Components/Inputs/TextField/IbssTextField";
import IbssCheckBox from "../../../../Components/Inputs/CheckBox/IbssCheckBox";
import { IbssComponent } from "../../../../Components/Core/BaseComponent/IbssComponent";
import IbssInputDropDown from "../../../../Components/Inputs/SelectList/IbssInputDropDown";
import { IFilterOptions } from "./EditEvents";

class EventManagement extends IbssComponent<IProps, IState>
{

  private get labels() { return appContext().labels; }

  constructor(props: IProps)
  {
    super(props);
    this.state = {};
  }


  public render(): JSX.Element
  {
    const {
      eventCapacity,
      eventCapacityChange,
      allowWaitingList,
      allowWaitingListChange,
      invitePermission,
      invitePermissionChange,
      havingCostToAttend,
      havingCostToAttendChange,
      ticketPrice,
      ticketPriceChange,
      isBroadcastToIBSS,
      broadcastToIBSSChange,
      isAttendeesCheckingIn,
      isAttendeesCheckingInChange,
      invitePermissionOptions
    } = this.props;

    return (
      <>
        <Grid item xs={12}>
          <Typography variant="h6" >
            {this.labels.OneLens_EventList_ManageEventTitle}
          </Typography>
          <Typography variant="subtitle1" marginBottom={2}>
            {this.labels.OneLens_EventList_ManageEventSubtitle}
          </Typography>
          <IbssTextField
            fullWidth
            label={this.labels.funcEventCapacity_S}
            name="phone"
            type="number"
            inputProps={{ min: 0 }}
            value={eventCapacity}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => eventCapacityChange(event.target.value)}

          />
        </Grid>
        <Grid item xs={12}>
          <IbssCheckBox
            label={this.labels.funcAllowWaitingList_L}
            checked={allowWaitingList}
            onClicked={(event: React.ChangeEvent<HTMLInputElement>) => allowWaitingListChange(event.target.checked)}
          />
        </Grid>
        <Grid item xs={12}>
          <IbssInputDropDown
            disabled={this.props.isEditMode}
            onChange={e => invitePermissionChange(e.target.value)}
            value={invitePermission}
            required
            inputLabel={this.labels.funcInvitePermission_L}
            id="invitePermission"
            options={invitePermissionOptions}
            helperText={this.labels.Flex_CreateEvent_InvitePermissionTooltip}
          />
        </Grid>
        <Grid item xs={12}>
          <IbssCheckBox
            label={this.labels.funcCostToAttend_L}
            checked={havingCostToAttend}
            onClicked={(event: React.ChangeEvent<HTMLInputElement>) => havingCostToAttendChange(event.target.checked)}
          />
        </Grid>
        {havingCostToAttend && <Grid item xs={12}>
          <IbssTextField
            fullWidth
            label={this.labels.funcTicketPrice_S}
            name="phone"
            type="number"
            value={ticketPrice}
            required={this.props.havingCostToAttend}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => ticketPriceChange(event.target.value)}
            inputProps={{ min: 0 }}
          />
        </Grid>}
        <Grid item xs={12}>
          <IbssCheckBox
            label={this.labels.funcBroadcastEventToIBSS_L}
            checked={isBroadcastToIBSS}
            onClicked={(event: React.ChangeEvent<HTMLInputElement>) => broadcastToIBSSChange(event.target.checked)}
          />
        </Grid>
        <Grid item xs={12}>
          <IbssCheckBox
            label={this.labels.funcCheckInAttendees_L}
            checked={isAttendeesCheckingIn}
            onClicked={(event: React.ChangeEvent<HTMLInputElement>) => isAttendeesCheckingInChange(event.target.checked)}
          />
        </Grid>
      </>
    );
  }
}

export default EventManagement;

interface IProps 
{
  isEditMode: boolean;
  eventCapacity: number;
  eventCapacityChange: (value: string) => void;
  allowWaitingList: boolean;
  allowWaitingListChange: (value: boolean) => void;
  invitePermission: string;
  invitePermissionChange: (value: string) => void;
  havingCostToAttend: boolean;
  havingCostToAttendChange: (value: boolean) => void;
  ticketPrice: number;
  ticketPriceChange: (value: string) => void;
  isBroadcastToIBSS: boolean;
  broadcastToIBSSChange: (value: boolean) => void;
  isAttendeesCheckingIn: boolean;
  isAttendeesCheckingInChange: (value: boolean) => void;
  invitePermissionOptions: IFilterOptions[];
}

interface IState 
{
}

export interface ICallToAction
{
  id: string;
  title: string;
  description: string;
  buttonLabel: string;
  src: string;
  imageAlt: string;
  route: string;
  permissions: boolean;
}

